import { DateTime } from 'luxon'

const utc2local = (value) => DateTime.fromISO(value, { zone: 'utc' }).toLocal()
const zebraTxPowers = Object.fromEntries(Array.from({ length: 201 }, (_, i) => [i, 1000 + i * 10]))

const formatters = {
  installedOn: (value) => (value && value.name ? value.serialNumber : ''),
  formatObj: (value) =>
    Object.keys(value)
      .map((key) => `${key} (${value[key].map((item) => `${item}`).join(', ')})`)
      .join(', '),
  tags: (values) => (values && values.length > 0 ? values.join(', ') : ''),
  formatFieldsDisplay: (values) =>
    values && values.length > 0 ? values?.map((e) => `${e.label}(${e.key})`).join(', ') : '',
  facility: (facility) => (facility && facility.name ? facility.name : ''),
  enterprise: (enterprise) => (enterprise && enterprise.name ? enterprise.name : ''),
  site: (s) => (s || {}).alias || (s || {}).name || '',
  category: (category) => (category && category.name ? category.name : ''),
  zebraStartTriggerType: (type) => type?.substring(19) || '',
  zebraStopTriggerType: (type) => type?.substring(18)?.replaceAll('_', ' ') || '',
  zebraReaderType: (type) => type.substring(5),
  impinjKeepAliveConfig: (value, item) => {
    if (!item.keepAlivesEnabled) return 'NOT ENABLED'
    else return 'ENABLED ' + item.keepAlivesPeriodMillis + 'ms'
  },
  impinjLinkMonitoring: (value, item) => {
    if (!item.enableLinkMonitorMode) return 'NOT ENABLED'
    else return 'ENABLED(' + item.linkDownThreshold + ')'
  },
  mappedRolesJson: (roles) => (roles ? JSON.parse(roles).join(',') : ''),
  superHarpCapacity: (value, item) => `${item.maxCapacity} / ${item.thresholdCapacity} / ${item.remainingCapacity}`,
  superHarpFunction: (value, item) => {
    let formatted = (item.handwashEnabled ? '+' : '-') + 'HH '
    formatted += (item.inventoryEnabled ? '+' : '-') + 'INVENTORY '
    formatted += (item.useMotionSensor ? '+' : '-') + 'MOTION '
    formatted += item.usageMode
    return formatted
  },
  user: (user) => (user && user.name ? user.name : ''),
  role: (role) => (role && role.name ? role.name : ''),
  roleName: (v, k, it) => it?.name || '',
  friendlyRoleName: (value) => value?.replaceAll('_', ' ')?.replace('ROLE ', '') || '',
  roles: (roles) =>
    roles !== undefined && roles !== null && roles.length > 0
      ? roles.map((r) => r.name).reduce((acc, curr) => (acc ? acc + ', ' : '') + curr)
      : '',
  username: (username) =>
    username === null || !username.includes('@') ? username : username.substring(0, username.indexOf('@')),
  date: (value) => (value ? utc2local(value).toFormat('yyyy-MM-dd') : ''),
  datetime: (value) => (value ? utc2local(value).toFormat('yyyy-MM-dd HH:mm:ss') : ''),
  luxon: (value) => (value ? utc2local(value) : null),
  readZone: (rz) => (rz || {}).alias || (rz || {}).name || '',
  operator: (o) => (o && o.username ? o.username : ''),
  floorMap: (fm) => (fm || {}).identifier || '',
  micros: (value) =>
    value
      ? DateTime.fromMillis(value / 1000, { zone: 'utc' })
          ?.toLocal()
          ?.toFormat('yyyy-MM-dd HH:mm:ss')
      : '',
  facilities: (facs) => facs.map((d) => d.name).join(', '),
  enterprises: (ents) => (ents?.map((e) => e.name) || []).join(', '),
  readerconfig: (cfg) => (cfg && cfg?.name ? cfg.name : ''),
  rfidReader: (rdr) => rdr.alias,
  rxSensitivity: (value, key, item) => (item.rxSensitivityMax ? 'max' : value),
  txPower: (value, key, item) => (item.txPowerMax ? 'max' : value),
  parent: (value) => (value && value.name ? `${value.serialNumber}(${value.name})` : ''),
  millisToSecond: (value) => (value ? value / 1000 : ''),
  millisToHour: (value) => (value ? value / 3600000 : ' '),
  minutesToDays: (minutes) => `${+minutes / 1440}`,
  minutesToHours: (minutes) => `${+minutes / 60}`,
  booleanToYesNo: (value) => (value ? 'YES' : 'NO'),
  broadcastRoles: (values) => (values && values.length > 0 ? values.join(', ') : ''),
  inventoryLocation: (value, row) => (row?.parent ? row?.installLocation?.slice(4) : value?.name),
  permissionName: (perm) =>
    `Allow user to perform ${perm.type} action for ${perm.value.replaceAll('/', ' ')} Page of the web platform`,
  zebraTxPower: (p) => zebraTxPowers[p] || p,
  millisToHumanReadable: (value) => {
    const seconds = Math.floor(value / 1000)
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60
    let result = ''
    if (hours > 0) {
      result += `${hours}h `
    }
    if (minutes > 0) {
      result += `${minutes}m `
    }
    if (remainingSeconds > 0) {
      result += `${remainingSeconds}s`
    }
    return result.trim() || '0s'
  },
}
export default formatters
